import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {HttpService} from '@tisa-group/cdk';
import {LOCAL_STORAGE} from '@ng-web-apis/common';
import {
  TISA_MEDIA_LIBRARY_TOKEN,
  TISA_MEDIA_LIBRARY_URL,
} from './tisa-media-library.providers';

@Injectable()
export class TisaMediaLibraryHttpService extends HttpService {
  constructor(
    @Inject(TISA_MEDIA_LIBRARY_URL) readonly api: string,
    @Inject(TISA_MEDIA_LIBRARY_TOKEN) readonly token: (...args: any[]) => string,
    @Inject(LOCAL_STORAGE) readonly localStorage: Storage,
    readonly http: HttpClient,
  ) {
    super();
  }
}
